/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Uno_Edu_Space_Sync_BlurbInputs */



/**
* | output |
* | --- |
* | "Syncing pulls the latest files from a connected source such as Google Drive, OneDrive, or another connector, and updates this space with new or changed files." |
*
* @param {Uno_Edu_Space_Sync_BlurbInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const uno_edu_space_sync_blurb = /** @type {((inputs?: Uno_Edu_Space_Sync_BlurbInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uno_Edu_Space_Sync_BlurbInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Synchronisierung ruft die neuesten Dateien aus einer verbundenen Quelle wie Google Drive, OneDrive oder einem anderen Connector ab und aktualisiert diesen Space mit neuen oder geänderten Dateien.")
	return /** @type {LocalizedString} */ ("Syncing pulls the latest files from a connected source such as Google Drive, OneDrive, or another connector, and updates this space with new or changed files.")
});